import Modal from '../../Modal';
import Component from './Component';

class RWDXGallery extends Component {
    private loading: boolean;
    private index: number;
    private thumbElements: HTMLAnchorElement[];
    private originalsSrc: string[];
    private modal: Modal;
    private imageElement: HTMLImageElement;
    private transitionTimeout: NodeJS.Timeout;
    private resizeTimeout: NodeJS.Timeout;
    private resizeListener: () => void;
    private keyListener: () => void;

    constructor(private name : string) {
        super();

        this.index = 0;
        this.originalsSrc = [];
        const thumbQuery = document.querySelectorAll(`[data-rwdx-gallery-name=${this.name}]`);
        this.thumbElements = [].slice.call(thumbQuery) as HTMLAnchorElement[];
        this.imageElement = new Image();

        for (let i = 0; i < this.thumbElements.length; i++) {
            this.thumbElements[i].setAttribute(
                'data-rwdx-gallery-index',
                i.toString()
            );
            this.originalsSrc.push(this.thumbElements[i].href)
        }

        this.modal = new Modal('', () => {
            this.imageElement.src = null;
            this.modal.windowElement.style.width = "5rem";
            this.modal.windowElement.style.minHeight = "5rem";
            window.removeEventListener("resize", this.resizeListener);
            window.removeEventListener("keydown", this.keyListener);
        }, false);

        this.modal.windowElement.appendChild(this.imageElement);
        this.modal.containerElement.classList.add('gallery-modal');
        this.modal.windowElement.classList.add('gallery-modal__window');

        const prevArrow = document.createElement('button');
        const nextArrow = document.createElement('button');

        prevArrow.className = "gallery-modal__control gallery-modal__control--prev";
        nextArrow.className = "gallery-modal__control gallery-modal__control--next";

        prevArrow.addEventListener("click", () => {
            this.move(-1);
        });

        nextArrow.addEventListener("click", () => {
            this.move(1);
        });

        this.modal.windowElement.insertAdjacentElement('beforeend', prevArrow);
        this.modal.windowElement.insertAdjacentElement('beforeend', nextArrow);

        this.resizeListener = this.resizeHandler.bind(this);
        this.keyListener = this.keyHandler.bind(this);
    }

    init() {
        this.imageElement.addEventListener('load', this.imageLoadHandler.bind(this));

        for (const thumb of this.thumbElements) {
            thumb.addEventListener("click", this.thumbClickHandler.bind(this));
        }
    }

    private openImage(src: string) {
        this.loading = true;
        this.imageElement.src = src;
        this.imageElement.style.display = "none";

        if (!this.modal.open) {
            this.modal.openModal();
            window.addEventListener("resize", this.resizeListener);
            window.addEventListener("keydown", this.keyListener);
        }
    }

    private imageLoadHandler() {
        const maxWidth = window.innerWidth - (window.innerHeight * 0.1);
        const maxHeight = window.innerHeight - (window.innerHeight * 0.1);
        let imageWidth = this.imageElement.naturalWidth;
        let imageHeight = this.imageElement.naturalHeight;
        const aspectRatio = imageWidth / imageHeight;

        if (imageWidth > maxWidth) {
            imageWidth = maxWidth;
            imageHeight = imageWidth / aspectRatio;
        }

        if (imageHeight > maxHeight) {
            imageHeight = maxHeight;
            imageWidth = imageHeight * aspectRatio;
        }

        this.modal.windowElement.style.width = imageWidth + "px";
        this.modal.windowElement.style.minHeight = imageHeight + "px";

        clearTimeout(this.transitionTimeout);

        this.transitionTimeout = setTimeout(() => {
            this.imageElement.style.display = "block";
            this.loading = false;
        }, 300);
    }

    private move(direction: -1|1) {
        this.index += direction;
        if (this.index < 0) this.index = this.thumbElements.length - 1;
        if (this.index > this.thumbElements.length - 1) this.index = 0;
        this.openImage(this.originalsSrc[this.index]);
    }

    private keyHandler(e: KeyboardEvent) {
        switch (e.key) {
            case "KeyA":
            case "ArrowLeft":
                this.move(-1);
                break;

            case "KeyD":
            case "ArrowRight":
                this.move(1);
                break;
        }
    }

    private resizeHandler() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
            this.imageLoadHandler();
        }, 100);
    }

    private thumbClickHandler(e: MouseEvent) {
        e.preventDefault();
        const currentTarget = e.currentTarget as HTMLAnchorElement;
        const { href } = currentTarget;
        const index = parseInt(currentTarget.dataset.rwdxGalleryIndex);
        this.index = index;
        this.openImage(href);
    }

    override cleanup() {
        this.imageElement.removeEventListener('load', this.imageLoadHandler.bind(this));

        for (const thumb of this.thumbElements) {
            thumb.removeEventListener("click", this.thumbClickHandler.bind(this));
        }
    }
}

export default RWDXGallery;